import { AppState } from '../types';

export const questionsSelector = (state: AppState) => state.funnel.questions;
export const productsSelector = (state: AppState) => state.funnel.products;
export const experimentsSelector = (state: AppState) =>
  state.funnel.experiments;
